/**
 * The field rules the acquisition products genuinely share. Prestito and CdQ
 * ask for a requested amount, a monthly income and a telephone in the same
 * words and judge them by the same bounds, so the bounds live here once; a
 * product whose policy differs keeps its own rule instead of widening these.
 */

/**
 * 8–15 digits, and no number made from one repeated digit (`3333333333`),
 * which is the placeholder an assisted call produces when nobody read a real
 * number out. The backend enforces the same rule.
 */
export const acquisitionPhoneRule = (value: string) => {
  const phone = value.trim();
  if (!/^\d{8,15}$/.test(phone)) return '8–15 cifre, senza spazi';
  return /^(\d)\1*$/.test(phone)
    ? 'Inserisci un numero di telefono reale'
    : true;
};

const MIN_REQUESTED_AMOUNT = 2_000;
const MAX_REQUESTED_AMOUNT = 75_000;

/** The public products' requested range, in whole euros. */
export const acquisitionRequestedAmountRule = (amount: number | null) => {
  if (amount === null) return 'Inserisci un importo positivo in euro interi';
  return amount >= MIN_REQUESTED_AMOUNT && amount <= MAX_REQUESTED_AMOUNT
    ? true
    : "L'importo deve essere tra €2.000 e €75.000";
};

const MIN_INCOME = 100;
const MAX_INCOME = 500_000;

const isIncome = (amount: number) => amount >= MIN_INCOME && amount <= MAX_INCOME;

/**
 * The monthly income, in whole euros. It starts blank on purpose: a prefilled
 * figure is one an untouched field would submit as if the customer had stated
 * it, and no validation can tell that apart from a real answer.
 */
export const acquisitionIncomeRule = (amount: number | null) => {
  if (amount === null) return 'Inserisci un reddito positivo in euro interi';
  return isIncome(amount)
    ? true
    : 'Il reddito mensile deve essere tra €100 e €500.000';
};

/**
 * A pensioner states a pension instead of a salary. The accepted range is the
 * same one, because this rule only says what a number may be; whether a pension
 * is large enough to qualify is the product's policy, not the field's.
 */
export const acquisitionPensionRule = (amount: number | null) => {
  if (amount === null) return 'Inserisci una pensione positiva in euro interi';
  return isIncome(amount)
    ? true
    : 'La pensione mensile deve essere tra €100 e €500.000';
};
